'use client'

import { useEffect, useState } from 'react'

interface AutoImageModalProps {
  imageUrl: string
  altText?: string
  showOnce?: boolean
  storageKey?: string // necessário se showOnce = true
}

export default function AutoImageModal({
  imageUrl,
  altText = 'Imagem do modal',
  showOnce = false,
  storageKey = 'imageModalShown',
}: AutoImageModalProps) {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (showOnce) {
      const alreadyShown = sessionStorage.getItem(storageKey)
      if (!alreadyShown) {
        setIsOpen(true)
        sessionStorage.setItem(storageKey, 'true')
      }
    } else {
      setIsOpen(true)
    }
  }, [showOnce, storageKey])

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="relative bg-white rounded-xl shadow-lg max-w-md w-full p-4">
        {/* Botão Fechar */}
        <button
          onClick={() => setIsOpen(false)}
          className="absolute top-2 right-2 text-gray-600 hover:text-red-500 text-xl font-bold bg-white rounded-full p-1 transition"
        >
          &times;
        </button>

        {/* Imagem */}
        <img
          src={imageUrl}
          alt={altText}
          className="rounded-lg object-contain w-full max-h-[70vh]"
        />
      </div>
    </div>
  )
}
